import React from 'react';
import { connect } from 'react-redux';
import { branch, compose, renderComponent } from 'recompose';
import { get, isArray } from 'lodash';

import Loader from 'components/Core/Loader';

export const loadingFromStore = (keys, text = 'Loading...') => compose(
  connect(
    state => {
      let isLoading;
      if (isArray(keys)) {
        const loadingArr = keys.map(eachKey => get(state, eachKey));
        if (loadingArr.filter(isLoad => isLoad).length > 0) isLoading = true;
        else isLoading = false;
      } else isLoading = get(state, keys);
      return { loading: isLoading };
    }
  ),
  branch(({ loading: isLoading }) => isLoading, renderComponent(() => <Loader text={text} />))
);

export const loadingFromProps = (propsKey) => branch(props => props[propsKey], renderComponent(Loader));



// WEBPACK FOOTER //
// ./src/utils/HOCs/loading.js